<ion-header>
  <ion-toolbar>
    <ion-title> {{ 'personal.records.title' | translate }} </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p class="ion-no-margin">
    {{'personal.records.message' | translate}}
  </p>

  <me-customer-ion-item
    class="ion-margin-top"
    [customerId]="customerId"
    [details]="false"
  />

  <ng-container *ngFor="let exercise of exercises">
    <div class="ion-margin-bottom" *ngIf="exerciseMap[exercise.id]">
      <h3>{{ exercise.name }}</h3>
      <ion-item fill="outline" lines="none" class="filter-item">
        <ion-icon slot="start" name="filter"></ion-icon>
        <ion-select
          [compareWith]="compareWith"
          [label]="'personal.records.select.label' | translate"
          labelPlacement="floating"
          [value]="selectedRecords[exercise.id]"
          (ionChange)="selectRecord(exercise.id, $event.detail.value)"
        >
          <ion-select-option *ngFor="let record of exerciseMap[exercise.id]" [value]="record">
            {{ record.label }}: {{ record.weightValue }} <me-unit-of-measure />
          </ion-select-option>
        </ion-select>
      </ion-item>
    </div>
  </ng-container>
</ion-content>
<ion-footer class="ion-padding">
  <ion-row class="buttons-container ion-justify-content-end">
    <ion-button color="secondary" (click)="dismiss()">
      {{ 'personal.records.confirm' | translate }}
    </ion-button>
  </ion-row>
</ion-footer>
